// ── Digest text assembly ──────────────────────────────────
// Shared by the dashboard (preview, test and send-now) and the
// scheduled-send API, so every path builds the email identically.

import { format, parseISO } from 'date-fns'

// "2026-10-16" → "Friday, October 16". parseISO reads a date-only string as
// local midnight, so the weekday doesn't shift for viewers west of UTC.
export function formatIssueDate(sendDate) {
  return format(parseISO(sendDate), 'EEEE, MMMM d')
}

export function hasDraft(story) {
  return !!(story.edited_text || story.draft_text)
}

export function storyToDigestText(s) {
  const body = s.edited_text || s.draft_text || ''
  const hasHeadline = body.includes('## ') || body.startsWith(s.sport_slug)
  let text = ''
  if (!hasHeadline && s.headline) text += s.sport_slug + '\n\n## ' + s.headline + '\n\n'
  if (s.image_url) {
    const paragraphs = body.split('\n\n').filter(p => p.trim())
    const mid = Math.floor(paragraphs.length / 2)
    // Always pass both fields explicitly: "url | caption || credit"
    // emailBuilder splits on ' || ' to get caption and credit separately
    const caption = s.image_caption || ''
    const credit = s.image_credit || ''
    const meta = caption || credit ? ' | ' + caption + ' || ' + credit : ''
    text += paragraphs.slice(0, mid).join('\n\n') +
      '\n\nSTORY_IMAGE: ' + s.image_url + meta + '\n\n' +
      paragraphs.slice(mid).join('\n\n')
  } else {
    text += body
  }
  return text
}

export function buildDigestText({ sendDate, intro, stories }) {
  let digest = formatIssueDate(sendDate) + '\n\n'
  if (intro) digest += '*' + intro.replace(/^\*|\*$/g, '') + '*\n\n---\n\n'
  for (const s of stories.filter(hasDraft)) digest += storyToDigestText(s) + '\n\n---\n\n'
  return digest
}
